import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import NewsFeed from "./components/list";

const Home = () => {
  const Location = useLocation();
  return (
    <>
      <div className="main-page-container">
        <Routes>
          <Route
            path={`/`}
            element={<Navigate replace="/" to={`${Location.pathname}/newsfeed`} />}
          ></Route>
          <Route path={"newsfeed"} element={<NewsFeed />}></Route>
        </Routes>
      </div>
    </>
  );
};

export default Home;
